// extracted by mini-css-extract-plugin
export var checkBox = "ucits-module--checkBox--uM4Bw";
export var checkBoxWrap = "ucits-module--checkBoxWrap--FoXBg";
export var disclaimerForm = "ucits-module--disclaimerForm--RSMIy";
export var docList = "ucits-module--docList--cA6DJ";
export var footerCopy = "ucits-module--footerCopy--8qyot";
export var page404Title = "ucits-module--page404-title--zO195";
export var shareList = "ucits-module--shareList--URYXm";